import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { getCurrentUser } from 'aws-amplify/auth'
import { Spinner } from 'react-bootstrap'

function PrivateRoute({ children }) {
  const [authState, setAuthState] = useState('loading') // 'loading' | 'authenticated' | 'unauthenticated'

  useEffect(() => {
    getCurrentUser()
      .then(() => setAuthState('authenticated'))
      .catch(() => setAuthState('unauthenticated'))
  }, [])

  if (authState === 'loading') {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Checking authentication…</span>
        </Spinner>
      </div>
    )
  }

  if (authState === 'unauthenticated') {
    return <Navigate to="/admin" replace />
  }

  return children
}

export default PrivateRoute
